// external-vendor-renderer.component.ts
import { Component } from '@angular/core';
import { ICellRendererAngularComp, ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams, ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-external-vendor-renderer',
  template: `
    <div *ngIf="!params">Loading...</div>
    <div *ngIf="params && isEditing" class="range-container">
      <mat-select
        class="select"
        [(ngModel)]="operator"
        (selectionChange)="onValueChange()"
      >
        <mat-option *ngFor="let item of operatorType" [value]="item.value">
          {{ item.value }}
        </mat-option>
      </mat-select>
      <input
        class="value"
        type="number"
        [(ngModel)]="target"
        (change)="onValueChange()"
        placeholder="Target"
      />
    </div>
    <div *ngIf="params && !isEditing" class="range-container view-mode">
      <span class="operator-display">{{ operator }}</span>
      <span class="value-display">{{ target || 'No Value' }}</span>
    </div>
  `,
  styles: [`
    .range-container {
      box-sizing: border-box;
      height: 49px;
      border: 1px solid #c8c9cc;
      border-radius: 4px;
      display: flex;
      align-items: center;
      /* margin: 0.5rem; */
      /* padding: 0 10px; */
    }
    .select {
      width: 80px;
      text-align: center;
      font-size: 14px;
    }
    .value {
      width: 80px;
      border: none;
      text-align: center;
      color: #222222;
      font-family: Roboto;
      background-color: transparent;
      font-size: 14px;
      outline: none;
    }
    .view-mode {
      justify-content: space-between;
    }
    .operator-display {
      width: 80px;
      text-align: center;
      font-size: 14px;
      color: #222222;
    }
    .value-display {
      width: 80px;
      text-align: center;
      font-size: 14px;
      color: #222222;
    }
  `]
})
export class ExternalVendorRendererComponent implements ICellRendererAngularComp, ICellEditorAngularComp {
  params: any;
  isEditing: boolean = false;
  operator: string = '=';
  target: string = '';
  operatorType = [
    { value: '=' },
    { value: '<>' },
    { value: '>' },
    { value: '<' },
    { value: '>=' },
    { value: '<=' }
  ];

  agInit(params: ICellRendererParams | ICellEditorParams): void {
    this.params = params;
    this.isEditing = !!(params as ICellEditorParams).colDef.cellEditor;
    this.setValues(params.value || { operator: '=', target: '200' });
  }

  refresh(params: any): boolean {
    this.params = params;
    this.setValues(params.value || { operator: '=', target: '200' });
    return true;
  }

  getValue(): any {
    return {
      operator: this.operator,
      target: this.target
    };
  }

  private setValues(value: any): void {
    this.operator = value.operator || '=';
    this.target = value.target || '200';
  }

  onValueChange(): void {
    if (this.params && this.params.api) {
      const newValue = this.getValue();
      this.params.node.setDataValue(this.params.column.colId, newValue);
    }
  }
}